import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const EmptyStatusDescription = ({
  respondents,
  participants,
}: {
  respondents: number | undefined
  participants: number | undefined
}) => {
  return (
    <>
      <Box>
        {!!participants && (
          <Text weight="medium" color="grey1000" size="300">
            {i18n.t('engagement_insights.survey_widget.empty_status.participation')}
            &nbsp;
            <Text weight="semibold" color="grey1000" size="200">
              {respondents}/{participants}
            </Text>
          </Text>
        )}
      </Box>
      <Box>
        <Text weight="medium" color="grey800" size="100">
          {i18n.t('engagement_insights.survey_widget.empty_status.description')}
        </Text>
      </Box>
    </>
  )
}
export default EmptyStatusDescription
